import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDividerDashed20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDividerDashed20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.656 2.425c-.69 0-1.25.56-1.25 1.25v1.95a.75.75 0 1 1-1.5 0v-1.95a2.75 2.75 0 0 1 2.75-2.75h8.688a2.75 2.75 0 0 1 2.75 2.75v1.95a.75.75 0 0 1-1.5 0v-1.95c0-.69-.56-1.25-1.25-1.25zm0 15.15c-.69 0-1.25-.56-1.25-1.25v-1.95a.75.75 0 0 0-1.5 0v1.95a2.75 2.75 0 0 0 2.75 2.75h8.688a2.75 2.75 0 0 0 2.75-2.75v-1.95a.75.75 0 0 0-1.5 0v1.95c0 .69-.56 1.25-1.25 1.25zM3.75 9.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zm4.5.75A.75.75 0 0 1 9 9.25h2a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m6-.75a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDividerDashed20);
